import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../authNew/authSlice';
import { SharedPageLayout } from '../../shared/SharedPageLayout';
import './UserData.css';

// Renders a protected view of the authenticated user's profile data.
export function UserData() {
    const auth = useSelector(selectAuth);
    const navLinks = [
        { href: '/', label: 'Home' },
        { href: '/play-games-now', label: 'Play games now' }
    ];

    return (
        <SharedPageLayout
            brand="GIUGGIOLI.NET"
            links={navLinks}
            footerText="Neon Arcade Vault • Powered by Giuggioli.Net"
        >
            <div className="user-data__content">
                <div className="user-data__hero">
                    <div className="user-data__hero-title">Your Arcade Passport</div>
                    <div className="user-data__hero-subtitle">
                        Personal details linked to your account, styled to match the neon arcade vault.
                    </div>
                </div>

                <div className="user-data__header">
                    <div>
                        <div className="user-data__title">User Data</div>
                        <div className="user-data__subtitle">Authenticated profile details</div>
                    </div>
                    <div className="user-data__badge">Secure</div>
                </div>

                <div className="user-data__grid">
                    <div className="user-data__card">
                        <div className="user-data__card-label">Name</div>
                        <div className="user-data__card-value">{auth.displayName || 'Unknown'}</div>
                    </div>
                    <div className="user-data__card">
                        <div className="user-data__card-label">Email</div>
                        <div className="user-data__card-value">{auth.email || 'Not provided'}</div>
                    </div>
                    <div className="user-data__card">
                        <div className="user-data__card-label">User Id</div>
                        <div className="user-data__card-value">{auth.uid || 'Not available'}</div>
                    </div>
                </div>
            </div>
        </SharedPageLayout>
    );
}
